<template>
  <div
    v-if="
      timesheetFormStore.showCommentInput.show &&
      timesheetFormStore.showCommentInput.date === col.dateString
    "
    class="tw-flex tw-items-center tw-gap-xs"
  >
    <WdsButton
      class="tw-w-full tw-justify-center"
      success-subtle
      @click="handleConfirmComment(col.dateString)"
    >
      <WdsIcon name="checkmark" :size="12" />
    </WdsButton>
    <WdsButton class="tw-w-full tw-justify-center" error-subtle @click="handleCancelComment">
      <WdsIcon name="close" :size="12" />
    </WdsButton>
  </div>
  <div v-else class="tw-flex tw-justify-center">
    <WdsPopover placement="top">
      <template #trigger="{ togglePopover }">
        <WdsButtonGhost
          v-if="
            !timesheetFormStore.isViewOnly ||
            (timesheetFormStore.isViewOnly &&
              timesheetFormStore.tableDateEntries[col.dateString][row.entriesKey])
          "
          :disabled="timesheetFormStore.isDateDisabled(col.dateString)"
          class="tw-max-w-[100px] tw-relative"
          @click="
            timesheetFormStore.isViewOnly ? togglePopover() : handleShowCommentInput(col.dateString)
          "
        >
          <WdsIcon name="add-comment" :size="18" />
          <div
            v-if="timesheetFormStore.tableDateEntries[col.dateString][row.entriesKey]"
            class="tw-absolute -tw-top-0.5 -tw-right-1.5 tw-bg-indigo-400 tw-w-2 tw-h-2 tw-rounded-full"
          />
        </WdsButtonGhost>
      </template>
      <div class="tw-p-md">
        {{ timesheetFormStore.tableDateEntries[col.dateString][row.entriesKey] }}
      </div>
    </WdsPopover>
  </div>
</template>

<script setup lang="ts">
import { WdsButton, WdsButtonGhost, WdsIcon, WdsPopover } from '@worksome/wds-components'
import { useTranslation } from '@/composables/translation'
import { useTimesheetFormStore } from '@/components/Timesheet/store/useTimesheetFormStore'

interface Props {
  row: any
  col: any
}

const props = defineProps<Props>()

const { $t } = useTranslation()
const timesheetFormStore = useTimesheetFormStore()

const handleShowCommentInput = (dateString) => {
  timesheetFormStore.comment = timesheetFormStore.tableDateEntries[dateString].comments
  timesheetFormStore.showCommentInput.show = true
  timesheetFormStore.showCommentInput.date = dateString
}

const handleCancelComment = () => {
  timesheetFormStore.comment = ''
  timesheetFormStore.showCommentInput.date = ''
  timesheetFormStore.showCommentInput.show = false
}

const handleConfirmComment = (dateString) => {
  timesheetFormStore.tableDateEntries[dateString].comments = timesheetFormStore.comment
  handleCancelComment()
}
</script>
